// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ValidatedPhoneNumber_inputWrapper__Ao3FM","label":"ValidatedPhoneNumber_label__--HWt","inputError":"ValidatedPhoneNumber_inputError__cuYBF"};